import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "emisphere_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    const key = [item.product_id, item.size, item.flocage ? item.pseudo : ""].join("|");
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(20, i.quantity + item.quantity) } : i));
      }
      return [...prev, { ...item, key }];
    });
    setIsOpen(true);
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const setQty = (key, qty) =>
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, Math.min(20, qty)) } : i)));
  const clear = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      add,
      remove,
      setQty,
      clear,
      isOpen,
      openCart: () => setIsOpen(true),
      closeCart: () => setIsOpen(false),
      count: items.reduce((n, i) => n + i.quantity, 0),
      total: items.reduce((t, i) => t + (i.price + (i.flocage ? i.flocage_price : 0)) * i.quantity, 0),
    }),
    [items, isOpen]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
